module.exports = __webpack_public_path__ + "img/Adam.0d894d9b.jpg";